import { Spinner } from "@blueprintjs/core";
import React from "react";
import { connect, DispatchProp } from "react-redux";
import { MutationType } from "typegraph";

import { forceQueryRefresh } from "core/actions/paramsActions";
import { IMutationResult } from "core/service/mutation/IMutationService";
import ServiceRegistry from "core/util/ServiceRegistry";
import { ButtonView, IButtonViewProps } from "./Button.view";


interface IMutationButtonProps extends IButtonViewProps {
	clazz: any;
	params: any;
	method?: MutationType; // temporary, probably a better way to do this
	onSuccess?: (o: any) => void;
	onFailure?: (o: any) => void;
	clearCacheOnSuccess?: boolean;
}

interface IMutationButtonState {
	saving: boolean;
}

class MutationButton extends React.Component<IMutationButtonProps & DispatchProp, IMutationButtonState> {

	constructor(props: IMutationButtonProps & DispatchProp) {
		super(props);
		this.state = { saving: false };
		this.doQuery = this.doQuery.bind(this);
	}

	public render() {
		const { children, clazz, method, params, ...restProps } = this.props;

		return (
			<ButtonView
				{...restProps}
				onClick={this.doQuery}
				disabled={restProps.disabled || this.state.saving}
			>
				{this.state.saving ? <Spinner size={12} /> : this.props.children}
			</ButtonView>
		);
	}

	private async doQuery() {
		const { method, clazz, params } = this.props;

		this.setState({ saving: true }, async () => {
			try {
				let res;
				if (MutationType.DELETE === method) {
					res = await ServiceRegistry.getMutationService().delete(this.props.params, clazz);
				} else {
					res = await ServiceRegistry.getMutationService().save(this.props.params, clazz);
				}

				this.setState({ saving: false }, () => this.onSuccess(res));
			} catch (error) {
				console.error("GraphQL Error:", error);
				this.setState({ saving: false }, () => this.onFailure(error)); // Reset saving state even if there's an error
			}
		});
	} catch(error) {
		console.error("Unexpected Error:", error);
		this.setState({ saving: false }); // Reset saving state if outer try fails
	}

	private onSuccess = (result: IMutationResult<any>) => {
		const { clearCacheOnSuccess, dispatch, onSuccess } = this.props;
		if (typeof onSuccess === 'function') {
			onSuccess(result);
		}
		if (clearCacheOnSuccess) {
			dispatch(forceQueryRefresh());
		}
	}
	private onFailure = (error) => {
		const { clearCacheOnSuccess, dispatch, onSuccess, onFailure } = this.props;
		onFailure(error);
	}
}

export default connect()(MutationButton) as React.ComponentType<IMutationButtonProps>;



// WEBPACK FOOTER //
// ./src/common/views/button/MutationButton.tsx